
export default {
  GET_VIP_DETAIL: 'GET_VIP_DETAIL'
}


// WEBPACK FOOTER //
// ./src/projects/vipCard/pages/home/store/types.js